export const SET_DATA = 'USE_REST_RESPONSE_SET_DATA';
export const SET_ERROR = 'USE_REST_RESPONSE_SET_ERROR';
export const SET_LOADING = 'USE_REST_RESPONSE_SET_LOADING';
export const RECEIVE_ERROR = 'USE_REST_RESPONSE_RECEIVE_ERROR';
export const RECEIVE_RESPONSE = 'USE_REST_RESPONSE_RECEIVE_RESPONSE';
export const RESET_STATE = 'USE_REST_RESPONSE_RESET_STATE';
